/* tslint:disable */
/**
* Kronos Api
* No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
*
* OpenAPI spec version: v1
* 
*
* NOTE: This class is auto generated by the swagger code generator program.
* https://github.com/swagger-api/swagger-codegen.git
* Do not edit the class manually.
*/


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { HistoryRequestDto } from '../model/historyRequestDto';
import { SalesOrderDetailDto } from '../model/salesOrderDetailDto';
import { SalesOrderDetailDtoHistoryResultDto } from '../model/salesOrderDetailDtoHistoryResultDto';
import { SalesOrderItemDto } from '../model/salesOrderItemDto';
import { SalesOrderSearchDto } from '../model/salesOrderSearchDto';
import { SalesOrderSearchDtoSearchResponse } from '../model/salesOrderSearchDtoSearchResponse';
import { SalesOrderSearchRequestDto } from '../model/salesOrderSearchRequestDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SalesOrderService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public create(body?: SalesOrderDetailDto, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderDetailDto>;
    public create(body?: SalesOrderDetailDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderDetailDto>>;
    public create(body?: SalesOrderDetailDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderDetailDto>>;
    public create(body?: SalesOrderDetailDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/sales-orders`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param salesOrderId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createItem(salesOrderId: string, body?: SalesOrderItemDto, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderItemDto>;
    public createItem(salesOrderId: string, body?: SalesOrderItemDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderItemDto>>;
    public createItem(salesOrderId: string, body?: SalesOrderItemDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderItemDto>>;
    public createItem(salesOrderId: string, body?: SalesOrderItemDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (salesOrderId === null || salesOrderId === undefined) {
            throw new Error('Required parameter salesOrderId was null or undefined when calling createItem.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.put(`${this.basePath}/api/sales-orders/${encodeURIComponent(String(salesOrderId))}/item`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSalesOrder(id: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public deleteSalesOrder(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public deleteSalesOrder(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public deleteSalesOrder(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteSalesOrder.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.delete(`${this.basePath}/api/sales-orders/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param salesOrderId 
     * @param itemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSalesOrderItem(salesOrderId: string, itemId: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public deleteSalesOrderItem(salesOrderId: string, itemId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public deleteSalesOrderItem(salesOrderId: string, itemId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public deleteSalesOrderItem(salesOrderId: string, itemId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (salesOrderId === null || salesOrderId === undefined) {
            throw new Error('Required parameter salesOrderId was null or undefined when calling deleteSalesOrderItem.');
        }
        if (itemId === null || itemId === undefined) {
            throw new Error('Required parameter itemId was null or undefined when calling deleteSalesOrderItem.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.delete(`${this.basePath}/api/sales-orders/${encodeURIComponent(String(salesOrderId))}/item/${encodeURIComponent(String(itemId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDetail(id: string, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderDetailDto>;
    public getDetail(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderDetailDto>>;
    public getDetail(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderDetailDto>>;
    public getDetail(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDetail.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/sales-orders/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSalesOrderHistory(body: HistoryRequestDto, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderDetailDtoHistoryResultDto>;
    public getSalesOrderHistory(body: HistoryRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderDetailDtoHistoryResultDto>>;
    public getSalesOrderHistory(body: HistoryRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderDetailDtoHistoryResultDto>>;
    public getSalesOrderHistory(body: HistoryRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getSalesOrderHistory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/sales-orders/projectHistory`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSearch(id: string, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderSearchDto>;
    public getSearch(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderSearchDto>>;
    public getSearch(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderSearchDto>>;
    public getSearch(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getSearch.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/sales-orders/search/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public isTransmitterActive(observe?: 'body', reportProgress?: boolean): Promise<boolean>;
    public isTransmitterActive(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<boolean>>;
    public isTransmitterActive(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<boolean>>;
    public isTransmitterActive(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/sales-orders/transmitterActive`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public save(body?: SalesOrderDetailDto, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderDetailDto>;
    public save(body?: SalesOrderDetailDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderDetailDto>>;
    public save(body?: SalesOrderDetailDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderDetailDto>>;
    public save(body?: SalesOrderDetailDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/sales-orders`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param salesOrderId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveItem(salesOrderId: string, body?: SalesOrderItemDto, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderItemDto>;
    public saveItem(salesOrderId: string, body?: SalesOrderItemDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderItemDto>>;
    public saveItem(salesOrderId: string, body?: SalesOrderItemDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderItemDto>>;
    public saveItem(salesOrderId: string, body?: SalesOrderItemDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (salesOrderId === null || salesOrderId === undefined) {
            throw new Error('Required parameter salesOrderId was null or undefined when calling saveItem.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/sales-orders/${encodeURIComponent(String(salesOrderId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public search(body?: SalesOrderSearchRequestDto, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderSearchDtoSearchResponse>;
    public search(body?: SalesOrderSearchRequestDto, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderSearchDtoSearchResponse>>;
    public search(body?: SalesOrderSearchRequestDto, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderSearchDtoSearchResponse>>;
    public search(body?: SalesOrderSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/sales-orders/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendToAbacus(id: string, observe?: 'body', reportProgress?: boolean): Promise<SalesOrderDetailDto>;
    public sendToAbacus(id: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<SalesOrderDetailDto>>;
    public sendToAbacus(id: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<SalesOrderDetailDto>>;
    public sendToAbacus(id: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling sendToAbacus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/sales-orders/${encodeURIComponent(String(id))}/send`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

}
